import { render, staticRenderFns } from "./Print126Project5.vue?vue&type=template&id=b740ca0a&scoped=true&"
import script from "./Print126Project5.vue?vue&type=script&lang=js&"
export * from "./Print126Project5.vue?vue&type=script&lang=js&"
import style0 from "./Print126Project5.vue?vue&type=style&index=0&id=b740ca0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b740ca0a",
  null
  
)

export default component.exports